// extracted by mini-css-extract-plugin
export default {"shalinaToast":"toast_shalinaToast__C3hp9","toastTitle":"toast_toastTitle__wvi9Y","toastMsg":"toast_toastMsg__PR7KR"};